function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  id: "question-mark",
  fill: "#707070",
  d: "M3.3,4.1c0.2-0.2,0.4-0.5,0.8-0.7c0.3-0.2,0.5-0.4,0.7-0.6C4.9,2.6,5,2.4,5,2.1c0-0.3-0.1-0.5-0.4-0.7 C4.2,1.2,3.8,1.2,3.3,1.2c-0.8,0-1.5,0.2-2,0.7L0.7,1.4C1,1.1,1.4,0.8,1.8,0.7c0.5-0.2,1-0.2,1.5-0.2c0.8,0,1.4,0.1,1.8,0.4 C5.6,1.1,5.9,1.5,5.9,2c0,0.4-0.1,0.7-0.3,0.9C5.4,3.1,5.2,3.4,4.8,3.7C4.5,3.9,4.3,4.1,4.1,4.3S3.9,4.7,3.9,5H3.1 C3.1,4.6,3.2,4.3,3.3,4.1z M3.1,7.2C2.9,7,2.9,6.9,2.9,6.8s0.1-0.3,0.2-0.4c0.1-0.1,0.3-0.2,0.5-0.2S3.8,6.2,4,6.3 c0.1,0.1,0.2,0.3,0.2,0.4C4.1,6.9,4.1,7,4,7.2C3.8,7.3,3.7,7.3,3.5,7.3S3.2,7.3,3.1,7.2z"
}));

var SvgHelp = function SvgHelp(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 6.5 8",
    style: {
      enableBackground: "new 0 0 6 8"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHelp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/help.db04947c.svg";
export { ForwardRef as ReactComponent };